"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reservationPrice = void 0;
const activity_1 = require("../activity");
const sumPaymentReceipts_1 = require("./sumPaymentReceipts");
const number_1 = require("../number");
function instructorsPriceInEuro(instructors, instructorPriceInEuro) {
    if (!instructorPriceInEuro || !instructors || instructors.length === 0) {
        return 0;
    }
    return instructors.length * instructorPriceInEuro;
}
const reservationPrice = (activityPrice, instructors, instructorPriceInEuro, refunds, discount) => {
    const refundsSum = sumPaymentReceipts_1.sumReceipts(refunds);
    const instructorsPrice = instructorsPriceInEuro(instructors, instructorPriceInEuro);
    const effectiveDiscount = Math.max(0, discount || 0);
    const effectiveRefund = Math.max(0, refundsSum || 0);
    return {
        activity: activity_1.filterEmptyGroup(activityPrice),
        instructors: instructorsPrice,
        discount: effectiveDiscount,
        refund: effectiveRefund,
        totalPrice: number_1.roundMoney(activityPrice.sum + instructorsPrice - effectiveDiscount),
    };
};
exports.reservationPrice = reservationPrice;
//# sourceMappingURL=reservationPrice.js.map